<template>
  <duringSpinSoundPicker
    :duringSpinSound="duringSpinSound"
    :duringSpinSoundVolume="duringSpinSoundVolume"
    @set-during-spin-sound="(v) => $emit('set-during-spin-sound', v)"
    @set-during-spin-sound-volume="(v) => $emit('set-during-spin-sound-volume', v)"
  />
</template>

<script setup>
import duringSpinSoundPicker from '@/components/audio/duringSpinSoundPicker.vue';

defineProps({
  duringSpinSound: { type: String, default: '' },
  duringSpinSoundVolume: { type: Number, default: 1 }
});

defineEmits(['set-during-spin-sound', 'set-during-spin-sound-volume']);
</script>

